import { createFileRoute } from "@tanstack/react-router"
import { AixContentBody } from "@aix/ui"
import { useAtomValue } from "jotai"
import { BreadcrumbBanner } from "~/components/BreadcrumbBanner"
import RedditStoryTemplate from "~/components/Templates/RedditStoryTemplate"
import AppLayout from "~/layouts/AppLayout"
import CustomHead from "~/components/SEOHead/CustomHead"
import { navStyleAtom } from "~/context/jotai"
import { getPageSEO } from "~/utils/seo"

const RedditStoryPage = () => {
  const breadcrumbItems = [{ label: "Home", href: "/home" }, { label: "Reddit Story" }]
  const redditStorySEO = getPageSEO("templates/reddit-story")
  const navStyle = useAtomValue(navStyleAtom)

  return (
    <>
      <CustomHead
        title={redditStorySEO.title}
        description={redditStorySEO.description}
        keywords={redditStorySEO.keywords}
        pageType={redditStorySEO.pageType}
        url="https://vidmax.ai/templates/reddit-story"
      />

      {navStyle !== "twoTier" && <BreadcrumbBanner items={breadcrumbItems} />}

      <AixContentBody className="sm:[--content-max-width:500px] md:[--content-max-width:700px] xl:[--content-max-width:960px]">
        <RedditStoryTemplate />
      </AixContentBody>
    </>
  )
}

function RedditStoryPageWrapper() {
  return (
    <AppLayout>
      <RedditStoryPage />
    </AppLayout>
  )
}

export const Route = createFileRoute("/templates/reddit-story")({
  component: RedditStoryPageWrapper,
})
